import { render, staticRenderFns } from "./modelComparisonResultView.vue?vue&type=template&id=24db4e42&scoped=true&"
import script from "./modelComparisonResultView.vue?vue&type=script&lang=js&"
export * from "./modelComparisonResultView.vue?vue&type=script&lang=js&"
import style0 from "./modelComparisonResultView.vue?vue&type=style&index=0&id=24db4e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db4e42",
  null
  
)

export default component.exports